import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { useJaws } from '@oms/jaws-react';
import { Body, Wrapper } from 'components/Component';
import Trend from 'components/Trend';
import Sparkline from 'components/Sparkline';
import formatNumber from 'utils/formatNumber';
import ExchangeSelect from 'components/ExchangeSelect/ExchangeSelect';
import ExchangeIndicator from 'components/ExchangeIndicator';
import * as ExchangeActions from 'state/exchange';
import { getExchange, getCountry } from 'state/exchange/selectors';
import Media from 'react-media';

import './IndexQuote.scss';

const IndexQuote = ({ itemSector, country }) => {
  const { items } = useJaws({
    itemSector,
    columns: 'LONG_NAME, ITEM, LAST, CHANGE, CHANGE_PCT, TIME',
  });
  const item = items.first();

  const { ITEM, LAST, CHANGE, CHANGE_PCT, TIME } = item ? item.toJS() : {};
  const time = moment.tz(TIME, 'Europe/Oslo');
  return (
    <Wrapper className="IndexQuote">
      <Media query="(max-width: 768px)">
        {small => (
          <Body>
            <span className="EXCHANGE_SELECT hidden-xs">
              <ExchangeSelect />
            </span>
            {small ? (
              <div className="HeaderIndex">
                <span className="LONG_NAME">{ITEM}</span>
                <span className="FLAG">
                  <ExchangeIndicator country={country} />
                </span>
              </div>
            ) : (
              <>
                <span className="FLAG">
                  <ExchangeIndicator country={country} />
                </span>
                <span className="LONG_NAME">{ITEM}</span>
              </>
            )}
            <span className="LAST">
              <Trend value={LAST}>{formatNumber(LAST, 2)}</Trend>
            </span>
            <span className="CHANGE">
              <Trend value={CHANGE}>{formatNumber(CHANGE, 2)}</Trend>
            </span>
            <span className="CHANGE_PCT">
              <Trend value={CHANGE_PCT}>{formatNumber(CHANGE_PCT, 2)}%</Trend>
            </span>
            <span className="SPARKLINE">
              {item && (
                <Sparkline
                  itemSector={itemSector}
                  item={{ values: item }}
                  height={18}
                  width={50}
                />
              )}
            </span>
            <span className="TIME">
              kl. {time && time.isValid() ? time.format('HH:mm:ss') : '-'}
            </span>
          </Body>
        )}
      </Media>
    </Wrapper>
  );
};

const mapStateToProps = state => ({
  itemSector: getExchange(state),
  country: getCountry(state),
});

export default connect(mapStateToProps, ExchangeActions, null, { pure: false })(
  IndexQuote,
);
